// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__1UU8J","buttons":"Spinner_buttons__xaXvX","button":"Spinner_button__6IYBy"};